const d = () => {
  const i = window.location.href.split("/");
  if (i[i.length - 1] === "" && i.pop(), i[i.length - 1] === "experienced-financial-advisors") {
    typeof window < "u" && window.lintrk && window.lintrk("track", { conversion_id: 13978929 });
    const t = new Image();
    t.src = "https://insight.adsrvr.org/track/pxl/?adv=w68u8xn&ct=0:r9t0g19&fmt=3", t.height = 1, t.width = 1, t.style.borderStyle = "none", t.alt = "";
    const n = "https://servedby.flashtalking.com/container/29701;143668;16428;iframe/?spotName=EAR_Experienced_Financial_Advisor_Video_View", e = document.createElement("iframe"), o = Math.floor(Math.random() * 1e6);
    e.src = `${n}&cachebuster=${o}`, e.style.position = "absolute", e.style.visibility = "hidden", e.style.width = "1px", e.style.height = "1px", e.style.border = "0", document.body.appendChild(e), window != null && window.gtag && window.gtag("event", "conversion", {
      send_to: "AW-1025051005/6RGmCKn24o4YEP2S5OgD"
    }), window != null && window.uetq && (window.uetq = window.uetq || [], window.uetq.push("event", "Experienced_Advisors_Video_Views", {}));
  }
};
export {
  d as f
};
//# sourceMappingURL=pixelPlacement-Dql18_0f.mjs.map
